import { defineMessages } from "react-intl";

export const messages = defineMessages({
  lowerThan: {
    defaultMessage: "lower than {value}",
    id: "qSCmIG",
  },
  greaterThan: {
    defaultMessage: "greater than {value}",
    id: "lZC/1a",
  },
});
